// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"dd31006766--wrapper--XiI2S","title":"dd31006766--title--p75SM"};